export default __webpack_public_path__ + "static/media/td.5f599127.svg";